import React from 'react';
import { Trans } from 'gatsby-plugin-react-i18next';
import { StaticImage } from 'gatsby-plugin-image';

import './perfect.business.less';

const PerfectBusiness = function () {
  return (
    <>

      <div className="o-perfectBusiness" id="how-works">
        <div className="m-globalContentContainer m-perfectBusiness__container">
          <div className="m-perfectBusiness__titleContainer">
            <div className="-page-title a-landingPage__title">
              <Trans>perfect.business.title</Trans>
            </div>
          </div>
          <div className="m-perfectbusiness__content">
            <div className="m-perfectbusiness__imageContainer">

              <StaticImage
                src="../../../../images/getLoan/get_loans_bs_2.png"
                alt="quotes image"
                title="quotes"
                className="m-perfectbusiness__image"
              />
            </div>
            <div className="m-perfectbusiness__textContainer">
              <div className="a-perfectbusiness__blockTitle"><Trans>perfect.business.finance</Trans></div>
              <div className="a-perfectbusiness__title"><Trans>perfect.business.finance.title</Trans></div>
              <div className="a-perfectbusiness__description"><Trans>perfect.business.finance.description</Trans></div>
              <div className="a-perfectbusiness__title"><Trans>perfect.business.data.title</Trans></div>
              <div className="a-perfectbusiness__description"><Trans>perfect.business.data.description</Trans></div>
              <div className="a-perfectbusiness__title"><Trans>perfect.business.fees.title</Trans></div>
              <div className="a-perfectbusiness__description"><Trans>perfect.business.fees.description</Trans></div>
            </div>
          </div>
        </div>
      </div>

      <div className="o-perfectBusiness -reverse">
        <div className="m-globalContentContainer m-perfectBusiness__container">
          <div className="m-perfectbusiness__content">
            <div className="m-perfectbusiness__imageContainer">
              <StaticImage
                src="../../../../images/getLoan/banner_lidya_credit_score.png"
                alt="quotes image"
                title="quotes"
                className="m-perfectbusiness__image"
              />
            </div>
            <div className="m-perfectbusiness__textContainer">
              <div className="a-perfectbusiness__blockTitle"><Trans>perfect.business.tech</Trans></div>
              <div className="a-perfectbusiness__title"><Trans>perfect.business.sameday.title</Trans></div>
              <div className="a-perfectbusiness__description"><Trans>perfect.business.sameday.description</Trans></div>
              <div className="a-perfectbusiness__title"><Trans>perfect.business.edge.title</Trans></div>
              <div className="a-perfectbusiness__description"><Trans>perfect.business.edge.description</Trans></div>
              <div className="a-perfectbusiness__title"><Trans>perfect.business.secure.title</Trans></div>
              <div className="a-perfectbusiness__description"><Trans>perfect.business.secure.description</Trans></div>
            </div>
          </div>
        </div>
      </div>

    </>

  );
};

export default PerfectBusiness;
